// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__32GEx","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1hpKW","gfeWrapper":"CalendarEvent_gfeWrapper__6_g_9"};